import Message from 'shared_components/message';
import { API_GET_METHOD } from 'global_config/constant-global';
import { axiosLabAPI } from '../axios';
import { showMessage } from 'services/settings/message';

export default async function fetchSection(isActive = null) {
	let sections = [];

	const p_is_active = [0, 1].includes(isActive) ? isActive : null;

	try {
		const url = `listofvalues/section`;

		const response = await axiosLabAPI({ 
			method: API_GET_METHOD, 
			url,
			...(p_is_active !== null ? { params: { p_is_active } } : {})
		 });
		const { data } = await response;

		sections = data.RECORDS || [];
	} catch (e) {
		// showMessage(e);
		console.log('section e =>')
	}

	return sections;
}